import request from '../../axios';

export const getDirectLoanRequest = async (loanRequestGuid: string) => {
  const {data}: {data: IDirectLoanRequest} = await request.get(
    `/api/v2/payment/direct-loan-request`,
    {
      params: {
        loan_request_guid: loanRequestGuid,
      },
    },
  );

  return data;
};
